import { NgModule, Type } from '@angular/core';
import { BrowserModule, Title }  from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { routing, routedComponents } from './app.routes';
import { AuthGuard, AuthenticationService, TokensService } from './services/index';

import { SharedModule } from './shared/shared.module';
 
@NgModule({
  declarations: [
    AppComponent,
    routedComponents
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    routing,
    SharedModule
  ],
  providers: [
      AuthenticationService,
      AuthGuard,
      Title,    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/app.module.ts